// assets/privacy.js
// FHL GO — Privacy Policy page behaviour (i18n + reveal + anchor offset)

(function () {
  console.log("[privacy.js] loaded");

  /* ===================== I18N TEXT ===================== */

  const I18N = {
    en: {
      toggleLabel: "EN | ES",

      // Breadcrumb / hero labels
      crumbHome: "Home",
      crumbPrivacy: "Privacy Policy",

      // Hero copy (used in page markup)
      privacyLabel: "Privacy Policy",
      privacyTitle: "Privacy Policy",
      privacyIntro:
        "This Privacy Policy describes how FHL GO collects, uses, and shares your information when you use our website and services.",

      // TOC labels
      toc_collect: "1. Personal Information We Collect",
      toc_use: "2. How We Use Information",
      toc_share: "3. Sharing & Third Parties",
      toc_ads: "4. Advertising & Analytics",
      toc_rights: "5. Your Rights",
      toc_retention: "6. Data Retention",
      toc_minors: "7. Minors",
      toc_changes: "8. Changes",
      toc_contact: "9. Contact",

      // Body lead labels
      rightsLead: "To exercise rights, contact",
      ctLead: "Questions? Email",

      // Body paragraphs
      collect_p1:
        "We collect Device Information (for example, IP address, browser type, time zone, and cookies) and site activity. If you create a shipment or account, we collect Order Information such as name, addresses, payment details, email, and phone number.",
      collect_p2:
        "We use cookies, log files, web beacons, tags, and pixels to operate the site and measure performance.",
      use_p1:
        "We use your information to provide services, process payments, arrange shipping, prevent fraud, communicate with you, and personalize content.",
      use_p2:
        "Where permitted, we send service updates and marketing communications consistent with your preferences.",
      share_p1:
        "We share information with service providers that help us operate the platform—for example Shopify, analytics providers, payment processors, and carriers.",
      share_p2:
        "We may disclose information where required by law or to protect our rights and the rights of others.",
      ads_p1:
        "We may use analytics and advertising partners to measure usage and show relevant ads. You can adjust preferences in your browser settings and through partner opt-out tools.",
      ads_p2:
        "We do not change our data practices when we receive a “Do Not Track” signal from your browser.",
      rights_p1:
        "Depending on your region, you may have rights to access, correct, delete, or restrict the use of your personal information.",
      retention_p1:
        "We retain order records and related information for as long as needed to provide services and to comply with legal requirements.",
      minors_p1:
        "Our services are not directed to individuals under the age of 13 (or local legal equivalent), and we do not knowingly collect information from them.",
      changes_p1:
        "We may update this Privacy Policy to reflect operational, legal, or regulatory changes, and will post the effective date when changes take effect.",

      // Footer / global bits (same style as Terms)
      followTitle: "FOLLOW US ON",
      companyTitle: "COMPANY",
      legalTitle: "LEGAL INFO",
      lnkAbout: "About Us",
      lnkServices: "Services",
      lnkBlog: "Blog",
      lnkTerms: "Terms of Service",
      lnkPrivacy: "Privacy Policy",
      lnkRefunds: "Refund Policy",
      copyright:
        "© 2025 FHL GO. Powered by Shopify — Developed by DIGIFUZEFX",
  },


    es: {
      toggleLabel: "ES | EN",

      crumbHome: "Inicio",
      crumbPrivacy: "Política de privacidad",

      privacyLabel: "Política de privacidad",
      privacyTitle: "Política de privacidad",
      privacyIntro:
        "Esta Política de Privacidad explica cómo FHL GO recopila, usa y comparte tu información cuando utilizas nuestro sitio web y servicios.",

      toc_collect: "1. Información que recopilamos",
      toc_use: "2. Cómo usamos la información",
      toc_share: "3. Divulgación a terceros",
      toc_ads: "4. Publicidad y analítica",
      toc_rights: "5. Tus derechos",
      toc_retention: "6. Conservación de datos",
      toc_minors: "7. Menores de edad",
      toc_changes: "8. Cambios",
      toc_contact: "9. Contacto",

      rightsLead: "Para ejercer derechos, escribe a",
      ctLead: "¿Dudas? Escribe a",

      collect_p1:
        "Recopilamos información del dispositivo (por ejemplo, IP, navegador, zona horaria y cookies) y actividad en el sitio. Si creas un envío o una cuenta, recopilamos información del pedido como nombre, direcciones, datos de pago, correo electrónico y teléfono.",
      collect_p2:
        "Usamos cookies, archivos de registro, web beacons, etiquetas y píxeles para operar el sitio y medir el rendimiento.",
      use_p1:
        "Utilizamos tu información para prestar servicios, procesar pagos, coordinar envíos, prevenir fraudes, comunicarnos contigo y personalizar el contenido.",
      use_p2:
        "Cuando la ley lo permite, enviamos actualizaciones del servicio y comunicaciones de marketing acordes con tus preferencias.",
      share_p1:
        "Compartimos información con proveedores que nos ayudan a operar la plataforma, como Shopify, servicios de analítica, procesadores de pago y transportistas.",
      share_p2:
        "Podemos divulgar información cuando la ley lo exija o para proteger nuestros derechos y los de terceros.",
      ads_p1:
        "Podemos utilizar socios de analítica y publicidad para medir el uso y mostrar anuncios relevantes. Puedes ajustar tus preferencias desde el navegador y las herramientas de baja de nuestros socios.",
      ads_p2:
        "No cambiamos nuestras prácticas de datos cuando recibimos una señal de “No rastrear” del navegador.",
      rights_p1:
        "Según tu región, puedes tener derecho a solicitar acceso, corrección, eliminación o restricción del uso de tu información personal.",
      retention_p1:
        "Conservamos los registros de pedidos y la información relacionada mientras sean necesarios para prestar el servicio y cumplir obligaciones legales.",
      minors_p1:
        "Nuestros servicios no están dirigidos a menores de 13 años (o equivalente legal local) y no recopilamos deliberadamente información de ellos.",
      changes_p1:
        "Podemos actualizar esta Política de Privacidad por motivos operativos, legales o regulatorios y publicaremos la fecha de vigencia cuando entren en efecto los cambios.",

      followTitle: "SÍGUENOS",
    companyTitle: "COMPAÑÍA",
    legalTitle: "INFO LEGAL",
    lnkAbout: "Quiénes somos",
    lnkServices: "Servicios",
    lnkBlog: "Blog",
    lnkTerms: "Términos del servicio",
    lnkPrivacy: "Política de privacidad",
    lnkRefunds: "Política de reembolsos",
    copyright: "© 2025 FHL GO. Con tecnología de Shopify — Desarrollado por DIGIFUZEFX",
  
    },
  };

  function applyLang(lang) {
    const dict = I18N[lang] || I18N.en;
    console.log("[privacy.js] applyLang:", lang);

    // Plain text nodes
    document.querySelectorAll("[data-i18n]").forEach((el) => {
      const key = el.dataset.i18n;
      if (!key) return;
      if (dict[key] !== undefined) el.textContent = dict[key];
    });

    // HTML-enabled nodes (if you ever add one, e.g. bold bits)
    document.querySelectorAll("[data-i18n-html]").forEach((el) => {
      const key = el.dataset.i18nHtml;
      if (!key) return;
      if (dict[key] !== undefined) el.innerHTML = dict[key];
    });

    // Language toggle pill (same selector set as services/terms)
    const toggle =
      document.getElementById("fhlgo-lang-toggle") ||
      document.getElementById("langToggleTop") ||
      document.querySelector(".fhlgo-lang-toggle") ||
      document.querySelector(".lang-toggle") ||
      document.querySelector('[data-i18n="toggleLabel"]');

    if (toggle && dict.toggleLabel) toggle.textContent = dict.toggleLabel;

    // Document title
    document.title =
      lang === "es"
        ? "FHL GO — Política de privacidad"
        : "FHL GO — Privacy Policy";

    // Persist shared language key
    try {
      localStorage.setItem("fhl_lang", lang);
    } catch (e) {}

    // Notify logo / other scripts
    try {
      const ev = new CustomEvent("fhlgo:lang-switch", { detail: { lang } });
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  document.addEventListener("DOMContentLoaded", function () {
    console.log("[privacy.js] DOMContentLoaded");

    // Initial language based on shared key
    const saved = (() => {
      try {
        return localStorage.getItem("fhl_lang") || "en";
      } catch (e) {
        return "en";
      }
    })();
    applyLang(saved);

    // Find the toggle button (same “spray and pray” selector)
    const toggle =
      document.getElementById("fhlgo-lang-toggle") ||
      document.getElementById("langToggleTop") ||
      document.querySelector(".fhlgo-lang-toggle") ||
      document.querySelector(".lang-toggle") ||
      document.querySelector('[data-i18n="toggleLabel"]');

    if (toggle) {
      console.log("[privacy.js] toggle found →", toggle);
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        let current = "en";
        try {
          current = localStorage.getItem("fhl_lang") || "en";
        } catch (err) {}
        const next = current === "en" ? "es" : "en";
        console.log("[privacy.js] toggle click →", next);
        applyLang(next);
      });
    } else {
      console.warn("[privacy.js] No language toggle found on this page");
    }

    // Respond if some other script fires fhlgo:lang-switch
    document.addEventListener("fhlgo:lang-switch", function (e) {
      const lang = (e && e.detail && e.detail.lang) || "en";
      console.log("[privacy.js] external fhlgo:lang-switch →", lang);
      applyLang(lang);
    });

    // Reveal-on-scroll scoped to privacy page
    if (
      !(
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      )
    ) {
      const io = new IntersectionObserver(
        (entries) => {
          for (const ent of entries) {
            if (ent.isIntersecting) {
              ent.target.classList.add("is-visible");
              io.unobserve(ent.target);
            }
          }
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );

      const nodes =
        document.querySelectorAll(".privacy-page [data-reveal]") ||
        document.querySelectorAll("[data-reveal]");

      nodes.forEach((el) => io.observe(el));
    }

    // Anchor offset under sticky header
    const header =
      document.querySelector(".fhlgo-country-header") ||
      document.querySelector(".site-header");
    const setOffset = () => {
      const h = header ? header.offsetHeight : 96;
      document.documentElement.style.setProperty(
        "--anchor-offset",
        h + 12 + "px"
      );
    };
    setOffset();
    window.addEventListener("resize", setOffset);
    window.addEventListener("load", setOffset);
  });
})();
